import { Badge, HStack } from "@chakra-ui/react";
import type { MediaModel } from "@src/utils/components/dropzone";
import { compact, countBy, map, uniq, upperCase } from "lodash";
import m from "mime-types";
import { observer } from "mobx-react-lite";
import type { FunctionComponent } from "react";

export const CellFiles: FunctionComponent<{
  files: MediaModel[];
}> = observer(function CellFiles({ files }) {
  const mimeTypes = compact(map(files, "mimeType"));
  const counts = countBy(mimeTypes);

  return (
    <HStack spacing="2">
      {map(uniq(mimeTypes), (t) => (
        <Badge colorScheme="grey" size="sm">
          {`${upperCase(m.extension(t) || "")} (${counts[t]})`}
        </Badge>
      ))}
    </HStack>
  );
});
